const state = {
  mobileSidebarOpen: false,
  mobileSidebarLinks: null,
  desktopSidebarOpen: false,
  desktopNavTree: null,
  desktopSidebarLinks: null,
  sidebarSubMenu: null,
  scrollAtTop: true,
  announcementBarExists: false,
}

const mutations = {
  toggleDesktopSidebar(state, subMenu) {
    const selectedLink = state.desktopNavTree && state.desktopNavTree.filter(link => link.handle === subMenu || link.title === subMenu)[0]
    if (subMenu && !selectedLink) return

    if (state.desktopSidebarOpen) {
      if (subMenu && subMenu != state.sidebarSubMenu) {
        // If sidebar is already open but user clicks on another submenu, show them that menu
        state.sidebarSubMenu = subMenu
        state.desktopSidebarLinks = selectedLink.links
        return
      }
    } else if (subMenu) {
      // If sidebar is closed and user clicked on a submenu, show them that menu
      state.sidebarSubMenu = subMenu
      state.desktopSidebarLinks = selectedLink.links
    }
    // Hide/show the sidebar
    state.desktopSidebarOpen = !state.desktopSidebarOpen
  },
  toggleMobileSidebar(state) {
    state.mobileSidebarOpen = !state.mobileSidebarOpen
  },
  closeDesktopSidebar(state) {
    state.desktopSidebarOpen = false
  },
  setAnnouncementBarExists(state, payload) {
    state.announcementBarExists = payload
  },
  setDesktopNavTree(state, desktopNavTree) {
    state.desktopNavTree = desktopNavTree
  },
  setMobileNavTree(state, mobileNavTree) {
    state.mobileNavTree = mobileNavTree
  },
  setScrollAtTop(state, payload) {
    state.scrollAtTop = payload
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
